import React from 'react';
import './Support.css';

function Support() {
  return (
    <div className="support">
      <div className="support-content">
        <h1>Know Your Ante? Trivia! Support</h1>
        
        <p className="intro">
          Need help, have feedback, or found a bug? Email us and we'll get back to you as soon as possible.
        </p>
        
        <section className="contact-section">
          <h2>Contact</h2>
          <p>
            <strong>Email:</strong> <a href="mailto:kyacontact@knowyourante.com">kyacontact@knowyourante.com</a>
          </p>
        </section>
        
        <section className="questions-section">
          <h2>Common Questions</h2>
          
          <div className="faq-item">
            <h3>Does the app require an internet connection?</h3>
            <p>No. Know Your Ante? Trivia! is designed to work offline.</p>
          </div>
          
          <div className="faq-item">
            <h3>Does the app collect any personal data?</h3>
            <p>No. We do not collect, sell, or share personal information. The app does not require an account.</p>
          </div>
          
          <div className="faq-item">
            <h3>How do I play with friends?</h3>
            <p>Choose Multiplayer, set a winning total, and take turns sharing one device. The app handles chip math automatically.</p>
          </div>
          
          <div className="faq-item">
            <h3>How does Solo Mode work?</h3>
            <p>Set a target total and try to reach it to win. Solo Mode is a streamlined challenge mode and does not use Hedge Cards.</p>
          </div>
        </section>
        
        <section className="troubleshooting-section">
          <h2>Troubleshooting</h2>
          
          <div className="faq-item">
            <h3>The app seems stuck or unresponsive.</h3>
            <p>Close the app completely and reopen it. If the issue continues, restart your device.</p>
          </div>
          
          <div className="faq-item">
            <h3>I found an incorrect question/answer.</h3>
            <p>Email us with the question text and what you believe the correct answer should be.</p>
          </div>
        </section>
        
        <section className="contact-info-section">
          <h3>When you contact support, please include:</h3>
          <ul>
            <li>Device model (example: iPhone 12)</li>
            <li>iOS version</li>
            <li>What you were doing when the issue happened</li>
            <li>A screenshot if possible</li>
          </ul>
        </section>
        
        <section className="privacy-link-section">
          <h2>Privacy</h2>
          <p>
            For details, see our <a href="/policy">Privacy Policy</a>
          </p>
        </section>
        
        <div className="last-updated">
          Last updated: February 2026
        </div>
        
        <div className="back-link">
          <a href="/">← Back to Home</a>
        </div>
      </div>
    </div>
  );
}

export default Support;
